import React from "react";
import styled from "styled-components";
import support from "../assets/support.png";
import { BsCheckLg, BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";

const SupportCompo = () => {
  return (
    <SupportMain>
      <SupportGrid>
        <SupportCard>
          <h3>24/7 Customer Support & Service</h3>
          <p>Our staffs will give you continuously marketing support to you.</p>
          <ul>
            <li>
              <div>
                <BsCheckLg className="check" />
              </div>
              All time support
            </li>
            <li>
              <div>
                <BsCheckLg className="check" />
              </div>
              Software after-sales support
            </li>
            <li>
              <div>
                <BsCheckLg className="check" />
              </div>
              Long-term technical-support
            </li>
            <li>
              <div>
                <BsCheckLg className="check" />
              </div>
              Call On +91 8888830536
            </li>
          </ul>
          <Link to="/pricing">
            Get Started For Free <BsArrowRight className="icon" />
          </Link>
        </SupportCard>
        <SupportCard>
          <img src={support} alt="" />
        </SupportCard>
      </SupportGrid>
    </SupportMain>
  );
};

export default SupportCompo;

const SupportMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem calc((100vw - 1000px) / 2);
`;

const SupportGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 500px;
  grid-gap: 0rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    margin: 15px 15px;
  }
`;

const SupportCard = styled.div`
  img {
    width: 110%;
    height: 90%;
  }
  h3 {
    font-size: 47px;
    font-weight: 600;
    color: #20204f;
    line-height: 65px;
    margin-top: 5px;
    text-align: left;
  }
  p {
    margin-top: 5px;
    font-weight: 500;
    color: #535353;
    width: 60%;
    text-align: left;
    margin-top: 1.5rem;
  }
  a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    color: #20204f;
    font-size: 17px;
    font-weight: 500;
    margin-top: 1.5rem;

    .icon {
      font-size: 20px;
      margin-left: 10px;
    }
  }
  ul {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    margin-top: 20px;
    list-style: none;
    margin-top: 1.5rem;

    li {
      color: #20204f;
      margin-right: 10px;
      margin-bottom: 1rem;
      font-size: 19px;
      display: flex;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #cfd3ff;
        border: 2px solid #20204f;
        height: 25px;
        width: 25px;
        border-radius: 50%;
        margin-right: 7px;

        .check {
          font-size: 16px;
          color: #20204f;
        }
      }
    }
  }
  @media only screen and (max-width: 991px) {
    h3 {
      font-size: 35px;
      font-weight: 600;
      color: #20204f;
      line-height: 45px;
      margin-top: 5px;
      text-align: left;
    }
    p {
      margin-top: 5px;
      font-weight: 500;
      color: #535353;
      width: 100%;
      text-align: left;
      margin-top: 1rem;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
`;
